export default {"src":"/_next/static/media/RightToWorkIcon.81bccc93.svg","height":20,"width":20};